mutation AddEntityToConstantContactList($input: ConstantContactAddEntityToListInput!) {
    constantContactAddEntityToList(input: $input) {
        entity {
            id
        }
    }
}
